<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content>
  <div class="control-item-component">
    <mat-card>
      <mat-card-title>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Create Bulletin</h2>
      </mat-card-title>
      <mat-card-content [formGroup]="form">

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >

          <div style="flex:49%">
            <mat-form-field class="example-full-width">
              <mat-label>Compliance area</mat-label>
              <mat-select  [(ngModel)]="bulletin.areaIds" name="complianceArea" formControlName="areaIds" multiple>
                <mat-option *ngFor="let complianceArea of complianceAreas" [value]="complianceArea.complianceAreaId">
                  {{complianceArea.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div style="flex:2%"></div>

          <div style="flex:49%">
            <mat-form-field class="example-full-width">
              <mat-label>Item</mat-label>
              <input matInput  name="name" [(ngModel)]="bulletin.name" formControlName="name">
            </mat-form-field>
          </div>

          <div style="flex:2%"></div>

        </div>

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <div style="flex:49%">
            <mat-form-field class="example-full-width">
              <mat-label>Type</mat-label>
              <input matInput  name="type" [(ngModel)]="bulletin.type" formControlName="type">
            </mat-form-field>
          </div>

          <div style="flex:2%"></div>

          <div style="flex:49%">
            <mat-form-field class="example-full-width">
              <mat-label>Choose a date</mat-label>
              <input matInput placeholder="Date" name="date" [(ngModel)]="bulletin.date" [matDatepicker]="picker"  formControlName="date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div style="flex:2%"></div>

        </div>

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <mat-form-field class="description-form">
            <mat-label>Article</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10"
                                  type="text"

                                  class="form-control"
                                  name="article"
                                  [(ngModel)]="bulletin.article"
                                  formControlName="article">
                        </textarea>
          </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <mat-form-field class="description-form">
            <mat-label>Analysis</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10"
                                  type="text"

                                  class="form-control"
                                  name="analysis"
                                  [(ngModel)]="bulletin.analysis"
                                  formControlName="analysis">
                        </textarea>
          </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
             >
          <mat-form-field class="description-form">
            <mat-label>Recommended actions</mat-label>
                        <textarea matInput
                                  cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10"
                                  type="text"

                                  class="form-control"
                                  name="recommendedActions"
                                  [(ngModel)]="bulletin.recommendedActions"
                                  formControlName="recommendedActions">
                        </textarea>
          </mat-form-field>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [disabled]="loading" (click)="onSave()" style="border-radius: 6px;">Save</button>
  <img *ngIf="loading"
       src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
